<template>
  <div class="internal-gateway-content">
    <div class="program-content">
      <div class="program-content-header">
        {{ $t('page_dnc_source_program_path') }}
        <a-button
          :disabled="!canTransmission"
          style="margin-left: 8px;border-radius: 2px;"
          class="program-bottom"
          @click="downloadProgram"
        >
          {{ $t('page_dnc_source_to_machining_program') }}<a-icon type="arrow-down" />
        </a-button>
        <!-- <a-button disabled style="margin-left: 8px;border-radius: 2px;">
          上传至当前选择路径<a-icon type="arrow-up" />
        </a-button> -->
      </div>
      <div
        id="program-onDrop-box"
        :class="canTransmission ? 'program-content-box' : 'program-content-box program-content-box-disabled'"
        v-if="sendMachine === 'a'"
      >
        <template v-if="!canTransmission">
          <div class="program-content-box-dis-header">
            <a-icon type="code" style="font-size: 22px;margin-right: 4px" />
            {{ $t('page_dnc_source_downloading_to_the_machining') }}
          </div>
        </template>
        <template v-else>
          <div
            v-dropbale="(meta) => onProgramDrop(meta)"
            @dragenter="(e) => programLight(e, 'program-onDrop-box', true)"
            @dragleave="(e) => programLight(e, 'program-onDrop-box', false)"
            @drop="(e) => programLight(e, 'program-onDrop-box', false)"
            class="program-content-box-header"
          >
            <div style="display: flex;align-items: center">
              <a-icon type="code" style="font-size: 22px;margin-right: 4px" />
              {{ $t('page_dnc_source_processing_program') }}
            </div>
            <div class="header-tip">
              <div>
                {{ $t('page_dnc_source_the_button_above') }}
              </div>
              <div class="program-tip-type">{{ $t('page_dnc_source_supporting_file') }}</div>
            </div>
          </div>
        </template>
        <div id="program-content-box-list" class="program-content-box-list">
          <template v-if="fileType === 'list'">
            <source-table
              @onSelectChange="(value) => onProgramChange(value)"
              @clickFile="(value) => clickProgramFile(value)"
              @dblclickFile="(value) => dblclickFile(value)"
              :selectedRowKeys="programRowKeys"
              :columns="columns"
              :dataSource="programList"
            ></source-table>
          </template>
          <div class="program-content-file-box" v-else>
            <template v-for="(item, index) in programList">
              <file
                :key="index"
                :file="item"
                :selectedRowKeys="programRowKeys"
                @check="(value) => checkProgram(value)"
                @clickFile="(value) => clickProgramFile(value)"
                @dblclickFile="(value) => dblclickFile(value)"
              ></file>
            </template>
          </div>
        </div>
      </div>
      <template v-else>
        <template v-if="!canTransmission">
          <div class="program-content-dis-box">
            <a-icon type="code" style="font-size: 42px;margin-bottom: 19px" />
            {{ $t('page_dnc_source_downloading_to_the_machining') }}
          </div>
        </template>
        <div
          id="program-onDrop-body"
          v-dropbale="(meta) => onProgramDrop(meta)"
          @dragenter="(e) => programLight(e, 'program-onDrop-body', true)"
          @dragleave="(e) => programLight(e, 'program-onDrop-body', false)"
          @drop="(e) => programLight(e, 'program-onDrop-body', false)"
          class="program-content-noD-box"
          v-else
        >
          <a-icon type="code" style="font-size: 42px;margin-bottom: 19px" />
          {{ $t('page_dnc_source_processing_program') }}
          <div class="noD-box-header-tip">
            <div>
              {{ $t('page_dnc_source_the_button_above') }}
            </div>
            <div class="program-tip-type">{{ $t('page_dnc_source_supporting_file') }}</div>
          </div>
        </div>
      </template>
    </div>
    <div class="documents-content">
      <div class="documents-content-header">
        {{ $t('page_dnc_source_process_file_path') }}
        <a-button
          style="margin-left: 8px;border-radius: 2px;"
          class="documents-bottom"
          @click="downloadFile"
        >
          {{ $t('page_dnc_source_to_process_file') }}<a-icon type="arrow-down" />
        </a-button>
        <!-- <a-button disabled style="margin-left: 8px;border-radius: 2px;">
          上传至当前选择路径<a-icon type="arrow-up" />
        </a-button> -->
      </div>
      <div id="documents-onDrop-box" class="documents-content-box" v-if="sendMachine === 'a'">
        <div
          v-dropbale="(meta) => onDocumentsDrop(meta)"
          @dragenter="(e) => documentsLight(e, 'documents-onDrop-box', true)"
          @dragleave="(e) => documentsLight(e, 'documents-onDrop-box', false)"
          @drop="(e) => documentsLight(e, 'documents-onDrop-box', false)"
          class="documents-content-box-header"
        >
          <div>
            <a-icon type="wallet" style="margin-right: 4px" />
            {{ $t('page_dnc_source_process_documents') }}
          </div>
          <div class="header-tip">
            <div>
              {{ $t('page_dnc_source_the_button_above') }}
            </div>
            <div class="documents-tip-type">{{ $t('page_dnc_source_type_process_do') }}</div>
          </div>
        </div>
        <div id="documents-content-box-list" class="documents-content-box-list">
          <template v-if="fileType === 'list'">
            <source-table
              @onSelectChange="(value) => onFileChange(value)"
              @clickFile="(value) => clickFileFile(value)"
              @dblclickFile="(value) => dblclickFile(value)"
              :selectedRowKeys="fileRowKeys"
              :columns="columns"
              :dataSource="fileList"
            ></source-table>
          </template>
          <div class="documents-content-file-box" v-else>
            <template v-for="(item, index) in fileList">
              <file
                :key="index"
                :file="item"
                :selectedRowKeys="fileRowKeys"
                @check="(value) => checkFile(value)"
                @clickFile="(value) => clickFileFile(value)"
                @dblclickFile="(value) => dblclickFile(value)"
              ></file>
            </template>
          </div>
        </div>
      </div>
      <div
        id="documents-onDrop-body"
        v-dropbale="(meta) => onDocumentsDrop(meta)"
        @dragenter="(e) => documentsLight(e, 'documents-onDrop-body', true)"
        @dragleave="(e) => documentsLight(e, 'documents-onDrop-body', false)"
        @drop="(e) => documentsLight(e, 'documents-onDrop-body', false)"
        class="documents-content-noD-box"
        v-else
      >
        <a-icon type="wallet" style="font-size: 42px;margin-bottom: 19px" />
        {{ $t('page_dnc_source_process_documents') }}
        <div class="noD-box-header-tip">
          <div>
            {{ $t('page_dnc_source_the_button_above') }}
          </div>
          <div class="program-tip-type">{{ $t('page_dnc_source_type_process_do') }}</div>
        </div>
      </div>
    </div>
    <preview-modal
      :visible="previewVisible"
      :data="previewData"
      @close="closePreview"
    ></preview-modal>
  </div>
</template>

<script>
import SourceTable from '../FileList/SourceTable.vue'
import PreviewModal from '../../../components/PreviewModal.vue'
import File from '../FileList/File.vue'
import { TransferDirectoryFileQueryServiceProxy } from '@/service-proxies/app-v2/dnc.service-proxies'
const tdfqsp = new TransferDirectoryFileQueryServiceProxy()

export default {
  components: {
    SourceTable,
    PreviewModal,
    File
  },
  data() {
    return {
      columns: [
        {
          title: this.$t('page_my_document_filenm'),
          dataIndex: 'name',
          ellipsis: true,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: this.$t('page_my_document_size'),
          dataIndex: 'contentLength',
          width: 88,
          ellipsis: true,
          scopedSlots: { customRender: 'contentLength' }
        },
        {
          title: this.$t('page_my_document_type'),
          dataIndex: 'fileType',
          key: 'fileType',
          customRender: (text) => {
            return text == 1
              ? this.$t('page_my_document_program')
              : this.$t('page_my_document_process')
          }
        }
      ],
      programList: [],
      fileList: [],
      programRowKeys: [],
      fileRowKeys: [],
      previewVisible: false,
      previewData: {}
    }
  },
  props: {
    sendMachine: {
      // a 单选; b 多选
      type: String,
      default: 'a'
    },
    selectedKey: {
      // 选择树节点
      type: String,
      default: ''
    },
    fileType: {
      type: String,
      default: 'file'
    },
    canTransmission: {
      type: Boolean,
      default: true
    },
    bottomUplod: {
      type: Number,
      default: 0
    }
  },
  watch: {
    selectedKey: {
      handler() {
        if (this.selectedKey.length) this.getData()
      },
      immediate: true,
      deep: true
    },
    bottomUplod: {
      handler() {
        if (this.selectedKey.length) this.getData()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {    
    dblclickFile(file) {
      this.previewVisible = true
      this.previewData = file
    },
    closePreview(){
      this.previewVisible = false
    },
    programLight(e, id, status) {
      e.preventDefault()
      const target = document.getElementById(id)
      target.style.border = status ? '1px solid #52c41a' : '1px dashed #52c41a'
    },
    onProgramDrop(meta) {
      if (typeof meta === 'string' || !meta) {
        return
      }
      this.$emit('downloadProgram')
    },
    documentsLight(e, id, status) {
      e.preventDefault()
      const target = document.getElementById(id)
      target.style.border = status ? '1px solid #597ef7' : '1px dashed #597ef7'
    },
    onDocumentsDrop(meta) {
      if (typeof meta === 'string' || !meta) {
        return
      }
      this.$emit('downloadFile')
    },
    downloadProgram() {
      this.$emit('downloadProgram')
    },
    downloadFile() {
      this.$emit('downloadFile')
    },
    checkProgram(file) {
      if (this.programRowKeys.indexOf(file.id) === -1) {
        this.programRowKeys.push(file.id)
      } else {
        const rowKeys = this.programRowKeys
        this.programRowKeys = rowKeys.filter((res) => res.indexOf(file.id) === -1)
      }
    },
    clickProgramFile(file) {
      this.programRowKeys = [file.id]
    },
    checkFile(file) {
      if (this.fileRowKeys.indexOf(file.id) === -1) {
        this.fileRowKeys.push(file.id)
      } else {
        const rowKeys = this.fileRowKeys
        this.fileRowKeys = rowKeys.filter((res) => res.indexOf(file.id) === -1)
      }
    },
    clickFileFile(file) {
      this.fileRowKeys = [file.id]
    },
    onProgramChange(programRowKeys) {
      this.programRowKeys = programRowKeys
    },
    onFileChange(fileRowKeys) {
      this.fileRowKeys = fileRowKeys
    },
    async getData() {
      this.programList = []
      this.fileList = []
      let id = ''
      if (this.selectedKey.indexOf('-') === -1) {
        id = this.selectedKey
      } else {
        const index = this.selectedKey.indexOf('-')
        id = this.selectedKey.substring(index + 1)
      }
      const data = await tdfqsp.fileList('', id)
      if (data && data.length) {
        const dataSource = data.map((res) => {
          res['name'] = res.originalFilename
          return res
        })
        this.programList = dataSource.filter((res) => res.fileType == 1)
        this.fileList = dataSource.filter((res) => res.fileType == 2)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.internal-gateway-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px;
  height: 100%;
  width: 100%;
  .program-content {
    width: calc(50% - 4px);
    height: 100%;
    border-radius: 2px;
    &-header {
      font-size: 14px;
      color: #52c41a;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-bottom: 8px;
      .program-bottom {
        background-color: #52c41a;
        color: #fff;
      }
      .program-bottom:disabled {
        color: rgba(0, 0, 0, 0.25);
        background-color: #f5f5f5;
      }
    }
    &-box {
      background-color: #f8f8f8;
      border-radius: 2px;
      border: dashed 1px #52c41a;
      height: calc(100% - 40px);
      &-dis-header {
        background-color: #f5f5f5;
        border-bottom: dashed 1px #d6d5d5;
        padding: 8px 16px;
        height: 61px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: rgba(0, 0, 0, 0.25);
      }
      &-header {
        padding: 8px 16px;
        font-size: 16px;
        letter-spacing: 0px;
        background-color: #f6ffed;
        color: #52c41a;
        border-bottom: 1px dashed #52c41a;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .header-tip {
          font-size: 12px;
          line-height: 22px;
          color: rgba(0, 0, 0, 0.85);
          .program-tip-type {
            color: #52c41a;
          }
        }
      }
      &-list {
        padding: 8px;
        height: calc(100% - 61px);
        overflow-y: auto;
      }
      .program-content-file-box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
      }
    }
    &-box-disabled{
      border: dashed 1px #d8d8d8;
    }
    &-noD-box {
      background-color: #f6ffed;
      border-radius: 2px;
      border: dashed 1px #52c41a;
      height: calc(100% - 40px);
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: #52c41a;
      .noD-box-header-tip {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        padding-top: 24px;
        .program-tip-type {
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
    &-dis-box {
      background-color: #f5f5f5;
      border-radius: 2px;
      border: dashed 1px #d8d8d8;
      height: calc(100% - 40px);
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      color: rgba(0, 0, 0, 0.25);
    }
  }

  .documents-content {
    width: calc(50% - 4px);
    height: 100%;
    border-radius: 2px;
    &-header {
      font-size: 14px;
      color: #597ef7;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-bottom: 8px;
      .documents-bottom {
        background-color: #597ef7;
        color: #fff;
      }
    }
    &-box {
      background-color: #f8f8f8;
      border: dashed 1px #597ef7;
      border-radius: 2px;
      height: calc(100% - 40px);
      &-header {
        padding: 8px 16px;
        font-size: 16px;
        letter-spacing: 0px;
        background-color: #f0f5ff;
        color: #597ef7;
        border-bottom: 1px dashed #597ef7;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .header-tip {
          font-size: 12px;
          line-height: 22px;
          color: rgba(0, 0, 0, 0.85);
          .documents-tip-type {
            color: #597ef7;
          }
        }
      }
      &-list {
        padding: 8px;
        height: calc(100% - 61px);
        overflow-y: auto;
      }
      .documents-content-file-box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
      }
    }
    &-noD-box {
      background-color: #f0f5ff;
      border-radius: 2px;
      border: dashed 1px #597ef7;
      height: calc(100% - 40px);
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: #597ef7;
      .noD-box-header-tip {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        padding-top: 24px;
        .program-tip-type {
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
  }
}
</style>
